<div class="modal-header py-2">
	<h5 class="modal-title">{{ mode === 'regions' ? 'Bereiche bearbeiten' : 'Punkte bearbeiten' }}</h5>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body py-2">
	<!-- Ladeanzeige -->
	<div *ngIf="!ready()" class="text-center py-3">
		<div class="spinner-border spinner-border-sm" role="status">
			<span class="visually-hidden">Laden...</span>
		</div>
	</div>

	<ng-container *ngIf="ready()">
		<!-- PUNKTE-MODUS: Filter + Rechteckauswahl -->
		<ng-container *ngIf="mode === 'points'">
			<!-- Filter-Bereich (nur mit Filter-Permission) -->
			<div class="p-2 bg-light rounded mb-3" *ngIf="aus.canI('use', 'filter')">
				<div class="d-flex align-items-center gap-2">
					<div class="form-check form-switch mb-0">
						<input class="form-check-input" type="checkbox"
							   [checked]="useGlobalFilter()"
							   [disabled]="oms.offlineMode() || !ps.isOwner()"
							   (change)="toggleGlobalFilter($any($event.target).checked)">
					</div>
					<span>Globaler Filter</span>
					<select *ngIf="useGlobalFilter()"
							class="form-select form-select-sm flex-grow-1"
							[ngModel]="globalFilterName()"
							[disabled]="oms.offlineMode() || !ps.isOwner()"
							(ngModelChange)="setGlobalFilter($event)">
						<option [ngValue]="null">Kein Filter</option>
						<option *ngFor="let f of availableFilters()" [ngValue]="f">{{ f }}</option>
					</select>
					<span *ngIf="!useGlobalFilter()" class="flex-grow-1"></span>
					<button class="btn btn-sm btn-outline-dark"
							(click)="openFilterDialog()"
							[disabled]="oms.offlineMode() || !ps.isOwner()"
							title="Filter bearbeiten">
						<i class="bi bi-funnel"></i>
					</button>
				</div>
				<div class="text-muted small mt-1">
					<span *ngIf="useGlobalFilter()">Ein Filter für alle Bereiche</span>
					<span *ngIf="!useGlobalFilter()">Individueller Filter pro Bereich möglich</span>
				</div>
			</div>
			<!-- Hinweis: Filter wird auf Projektbereich angewendet -->
			<div *ngIf="aus.canI('use', 'filter') && useGlobalFilter() && globalFilterName() && hasProjectSelections()"
				 class="alert alert-info py-1 px-2 mb-3 small">
				<i class="bi bi-info-circle me-1"></i>
				Filter wird auf die ausgewählten Bereiche angewendet
			</div>

			<!-- Rechteckauswahl -->
			<div class="accordion accordion-flush">
				<div class="accordion-item">
					<h2 class="accordion-header">
						<div class="accordion-button py-2 d-flex align-items-center">
							<button type="button" class="btn btn-sm btn-outline-dark me-2"
									title="Punkte per Rechteck auswählen"
									(click)="selectBoundsPoints()"
									[disabled]="oms.offlineMode() || !ps.isOwner()">
								<i class="bi bi-bounding-box"></i>
							</button>
							<span>Rechteckauswahl</span>
						</div>
					</h2>
					<div class="accordion-body py-2">
						<!-- Hinweis wenn keine Auswahl -->
						<p *ngIf="boundsSelections().length === 0" class="text-muted mb-0 small">
							Keine Rechteckauswahl vorhanden. Klicken Sie auf <i class="bi bi-bounding-box"></i> um einen Bereich auszuwählen.
						</p>
						<!-- Einzelne Rechteckauswahlen -->
						<div *ngFor="let sel of boundsSelections(); let i = index"
							 class="d-flex align-items-center gap-2 py-1">
							<div class="form-check form-switch mb-0 flex-shrink-0">
								<input class="form-check-input" type="checkbox"
									   [checked]="sel.active"
									   [disabled]="oms.offlineMode() || !ps.isOwner()"
									   (change)="toggleBoundsSelection(sel)">
							</div>
							<input class="form-control form-control-sm text-nowrap"
								   style="width: 100px; min-width: 80px;"
								   [value]="sel.name || ''"
								   [placeholder]="'Auswahl ' + (i + 1)"
								   [disabled]="oms.offlineMode() || !ps.isOwner()"
								   (blur)="renameBoundsSelection(sel, $any($event.target).value)">
							<span class="flex-grow-1"></span>
							<!-- Filter-Dropdown (nur wenn kein globaler Filter UND Filter vorhanden UND Permission) -->
							<select *ngIf="aus.canI('use', 'filter') && !useGlobalFilter() && availableFilters().length > 0"
									class="form-select form-select-sm flex-shrink-0" style="width: auto;"
									[ngModel]="sel.filterName"
									[disabled]="oms.offlineMode() || !ps.isOwner() || !sel.active"
									(ngModelChange)="setBoundsFilter(sel, $event)">
								<option [ngValue]="undefined">Alle</option>
								<option *ngFor="let f of availableFilters()" [ngValue]="f">{{ f }}</option>
							</select>
							<span class="badge flex-shrink-0"
								  [class.bg-primary]="sel.active"
								  [class.bg-secondary]="!sel.active">
								{{ getBoundsFilteredCount(i, sel) }}
							</span>
							<button class="btn btn-sm btn-outline-dark btn-xs flex-shrink-0"
									(click)="zoomToBoundsSelection(sel)"
									title="Zu Punkten zoomen">
								<i class="bi bi-search"></i>
							</button>
							<button class="btn btn-sm btn-outline-danger btn-xs flex-shrink-0"
									(click)="removeBoundsSelection(sel)"
									[disabled]="oms.offlineMode() || !ps.isOwner()"
									title="Auswahl löschen">
								<i class="bi bi-trash"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- BEREICHE-MODUS: Projektbereiche -->
		<ng-container *ngIf="mode === 'regions'">
			<div *ngIf="regionItems().length === 0" class="d-flex align-items-center mb-3">
				<span class="text-muted small flex-grow-1">Keine Projektbereiche definiert.</span>
				<button *ngIf="aus.canI('use', 'filter')" type="button" class="btn btn-sm btn-outline-dark"
						(click)="openFilterDialog()"
						[disabled]="oms.offlineMode() || !ps.isOwner()"
						title="Filter bearbeiten">
					<i class="bi bi-funnel"></i>
				</button>
			</div>

			<!-- Erläuterung -->
			<div *ngIf="regionItems().length > 0" class="d-flex align-items-center mb-2">
				<p class="text-muted small mb-0 flex-grow-1">
					Aktivierte Bereiche werden für die Offline-Synchronisation verwendet.
				</p>
				<button *ngIf="aus.canI('use', 'filter')" type="button"
						class="btn btn-sm p-0 me-2 info-btn"
						(click)="showFilterInfo()">
					<i class="bi bi-info-circle"></i>
				</button>
				<button *ngIf="aus.canI('use', 'filter')" type="button" class="btn btn-sm btn-outline-dark"
						(click)="openFilterDialog()"
						[disabled]="oms.offlineMode() || !ps.isOwner()"
						title="Filter bearbeiten">
					<i class="bi bi-funnel"></i>
				</button>
			</div>

			<!-- Spaltenüberschriften -->
			<div *ngIf="regionItems().length > 0" class="d-flex align-items-center gap-3 py-1 small text-muted border-bottom mb-1">
				<span style="width: 34px;" title="Für Offline-Sync aktivieren">Sync</span>
				<span>Name</span>
				<span *ngIf="aus.canI('use', 'filter') && !useGlobalFilter()">Filter</span>
				<span [style.width]="areaColumnWidth()" style="text-align: right;">Fläche</span>
				<!-- Platzhalter für Zoom-Button -->
				<span style="width: 26px;"></span>
				<!-- Alle löschen Button -->
				<button class="btn btn-sm btn-outline-danger btn-xs flex-shrink-0"
						(click)="deleteAllRegions()"
						[disabled]="oms.offlineMode() || !ps.canDeleteRegions()"
						title="Alle Bereiche löschen">
					<i class="bi bi-trash"></i>
				</button>
			</div>

			<!-- Einzelne Regions -->
			<div *ngFor="let item of regionItems(); let i = index"
				 class="d-flex align-items-center gap-3 py-1">
				<div class="form-check form-switch mb-0 flex-shrink-0" style="width: 34px;" title="Bereich für Offline-Synchronisation aktivieren">
					<input class="form-check-input" type="checkbox"
						   [checked]="item.active"
						   [disabled]="oms.offlineMode() || !ps.canEditRegions()"
						   (change)="toggleRegion(item)">
				</div>
				<input class="form-control form-control-sm region-name-input"
					   #regionNameInput
					   [value]="getRegionName(item)"
					   [placeholder]="'Bereich ' + (item.index + 1)"
					   [disabled]="oms.offlineMode() || !ps.canEditRegions()"
					   [size]="(getRegionName(item) || ('Bereich ' + (item.index + 1))).length || 5"
					   (blur)="renameRegion(item, regionNameInput.value)">
				<!-- Filter-Dropdown (nur wenn kein globaler Filter UND Permission) -->
				<select *ngIf="aus.canI('use', 'filter') && !useGlobalFilter()"
						class="form-select form-select-sm region-filter-select"
						[ngModel]="item.filterName"
						[disabled]="oms.offlineMode() || !ps.canEditRegions() || !item.active || availableFilters().length === 0"
						(ngModelChange)="setRegionFilter(item, $event)">
					<option [ngValue]="undefined">{{ availableFilters().length === 0 ? '–' : 'Alle' }}</option>
					<option *ngFor="let f of availableFilters()" [ngValue]="f">{{ f }}</option>
				</select>
				<!-- Fläche in ha -->
				<span class="text-muted small flex-shrink-0" [style.width]="areaColumnWidth()" style="text-align: right; white-space: nowrap;">{{ getRegionAreaHa(item) }} ha</span>
				<button class="btn btn-sm btn-outline-dark btn-xs flex-shrink-0"
						(click)="zoomToRegion(item)"
						title="Zu Bereich zoomen">
					<i class="bi bi-search"></i>
				</button>
				<button class="btn btn-sm btn-outline-danger btn-xs flex-shrink-0"
						(click)="deleteRegion(item)"
						[disabled]="oms.offlineMode() || !ps.canDeleteRegions()"
						title="Bereich löschen">
					<i class="bi bi-trash"></i>
				</button>
			</div>

			<!-- Buttons zum Erstellen neuer Bereiche -->
			<div *ngIf="!oms.offlineMode() && ps.canCreateRegions()" class="d-flex align-items-center gap-2 mt-3">
				<span>Neuer Bereich:</span>
				<button class="btn btn-sm btn-outline-dark" (click)="createRectangleRegion()" title="Rechteckigen Bereich auswählen">
					<i class="bi bi-square"></i>&nbsp;Rechteck
				</button>
				<button class="btn btn-sm btn-outline-dark" (click)="createPolygonRegion()" title="Polygon-Bereich zeichnen">
					<i class="bi bi-pentagon"></i>&nbsp;Polygon
				</button>
				<button class="btn btn-sm btn-outline-dark" (click)="createFreehandRegion()" title="Freihand-Bereich zeichnen">
					<img src="assets/img/draw-polygon-freehand.svg" class="custom-icon" alt="Freihand" style="width: 1em; height: 1em;">&nbsp;Freihand
				</button>
				<button class="btn btn-sm btn-outline-dark" (click)="importGeoJson()" title="Polygone aus Datei importieren (GeoJSON, GeoPackage, Shapefile)">
					<i class="bi bi-file-earmark-arrow-up"></i>&nbsp;Importieren
				</button>
			</div>

		</ng-container>
	</ng-container>
</div>
<div class="modal-footer py-2">
	<button type="button" class="btn btn-primary btn-sm" (click)="onClose()">Fertig</button>
</div>
